import Forms from './modules/Forms.js';
import Locations from './modules/Locations.js';
import MobileNavigation from './modules/MobileNavigation.js';
import Navigation from './modules/Navigation.js';

document.addEventListener('DOMContentLoaded', function() {

  Navigation();
  MobileNavigation();

  if ( jQuery('.m-locations-block__location').length ) {
    Locations();
  }

  if ( jQuery('.gform_wrapper').length ) {
    Forms();
  }

  // adjusting padding on heroes (client request after all content had been entered)
  var $firstColumn = jQuery(".entry-content > .wp-block-group > .wp-block-columns > .wp-block-column:first-child");
  // Check if the element exists
  if ($firstColumn.length > 0) {
      // Check if the style attribute contains "padding-left: 6.3%"
      if ($firstColumn.attr('style') && $firstColumn.attr('style').includes('padding-left:6.3%')) {
          // Change the padding-left to 19px
          $firstColumn.css('padding-left', '19px');
      }
  }

});
